import { ComponentIds } from '@inter-ikea-core/core';
import ProductInfoComponent from '../components/ProductInfoComponent';
import { PlannerEcsSystem } from './System';
import PlannerProductComponent from '../components/PlannerProductComponent';
/**
 * This system removes autoadapt from entities of specified producttypes once
 * they are added to the scene. Can be used when you want autoadapt when adding
 * it from the productmenu but not when your are dragging it in the scene.
 */
export class RemoveAutoAdaptSystem extends PlannerEcsSystem {
    constructor(coreApi, productTypes) {
        super(coreApi, 'RemoveAutoAdaptSystem', ComponentIds.IN_SCENE_COMPONENT_ID);
        this.coreApi = coreApi;
        this.productTypes = productTypes;
        this.mandatoryComponents = [PlannerProductComponent.id];
    }
    onAdd(entity) {
        const productType = entity.getComponent(ProductInfoComponent.id)
            ?.productType;
        if (productType && this.productTypes.includes(productType)) {
            entity.removeComponent(ComponentIds.AUTO_ADAPT_GUEST_COMPONENT_ID);
        }
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=RemoveAutoAdaptSystem.js.map